<template>
  <!-- 機器出荷詳細 -->
  <div id="KenshinShippingListDetail">
    <div id="container">
      <div class="labelTitle lable">企業検診 機器出荷詳細</div>
      <div class="result-area" style="font-size:20px;text-align:left;width:100%;">
        <table style="font-size:20px;text-align:left;width:100%;">
          <tr>
            <th style="width:12%;font-size:20px;">受付番号：</th>
            <td style="font-size:20px;padding-top:0px;">
              <span>{{data.receiptNumber}}</span>
              <span style="float:right;"><b-button class="backButton is-primary" v-on:click="back">戻る</b-button></span>
            </td>
          </tr>
          <tr>
            <th style="width:12%;font-size:20px;">機種：</th>
            <td style="font-size:20px;padding-top:0px;">{{getChoiceName(data.instrumentKind,kenshinDeviceList)}}</td>
          </tr>
          <tr>
            <th style="width:12%;font-size:20px;">ステータス：</th>
            <td style="font-size:20px;padding-top:0px;"><select id="status" style="width:10%;" v-model="shippingStatus" @change="changeShippingStatus"><option v-for="status in shippingStatusList" :key="status.code" :value="status.code">{{status.name}}</option></select></td>
          </tr>
          <tr>
            <th style="width:12%;font-size:20px;vertical-align:top;">コメント：</th>
            <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.belongsNote}}</td>
          </tr>
        </table>
        <!-- <div>
          <th style="width:20%;">受付番号：</th>
          <td style="margin-left:10px;font-size:20px;padding-top:5px;">
            <span>{{data.receiptNumber}}</span>
            <span style="float:right;"><b-button class="backButton is-primary" v-on:click="back">戻る</b-button></span>
          </td>
        </div>
        <div>
          <th style="width:20%;">機種：</th>
          <td style="font-size:20px;">{{getChoiceName(data.instrumentKind,kenshinDeviceList)}}</td>
        </div>
        <div>
          <th>ステータス：</th>
          <td style="font-size:20px;"><select id="status" v-model="shippingStatus" @change="changeShippingStatus"><option v-for="status in shippingStatusList" :key="status.code" :value="status.code">{{status.name}}</option></select></td>
        </div>
        <div>
          // <- v-if {{data.userMasterMemo}} ->
          <th style="vertical-align:top;">外部ユーザーコメント：</th>
          <td style="font-size:20px;">
            <span style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">test<br>TEST<br>てすと<br>テスト
            </span>
          </td>
        </div> -->
      </div>
      <div id="item-contens" style="margin-top:5px;">
        <div class="labelTitle lable">出荷作業チェック マスターシート</div>
        <div class="result-area">
          <div class="operation-area">
              <b-button class="operationButton is-primary" @click="clipboardCopy" :disabled="shippingDatas.length==0">クリップボードにコピー</b-button>
              <b-button class="operationButton is-primary" icon-left="truck-delivery-outline" @click="doShipping" :disabled="shippingStatus!=3 || shippingDatas.length==0">出荷済みにする</b-button>
          </div>
          <div class="resultTable-area">
            <b-table
                id="kenshinShippingListDetailTable"
                :data="shippingDatas"
                pagination-position="both"
                default-sort="user.first_name"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page">
                <template slot-scope="props">
                  <b-table-column field="shippingDate" label="出荷予定日" width="120" sortable centered>
                    {{props.row.shippingDate }}
                  </b-table-column>
                  <b-table-column field="status" label="ステータス" width="120" sortable>
                    {{getStatusName(props.row.status) }}
                  </b-table-column>
                  <b-table-column field="serial" label="シリアル" width="150" sortable >
                    {{props.row.serial}}
                  </b-table-column>
                  <b-table-column field="receiptNumber" label="受付番号" width="120" sortable >
                    {{props.row.receiptNumber }}
                  </b-table-column>
                  <b-table-column field="employeeCode" label="社員コード" width="120" sortable >
                    {{props.row.employeeCode }}
                  </b-table-column>
                  <b-table-column field="hospital" label="医療機関" width="200" sortable >
                    {{props.row.hospital }}
                  </b-table-column>
                  <b-table-column field="companyName" label="企業名" sortable >
                    {{props.row.companyName}}　{{props.row.officeName}}
                  </b-table-column>
                  <b-table-column field="zip" label="郵便番号" width="90" sortable >
                    {{props.row.zip }}
                  </b-table-column>
                  <b-table-column field="address" label="住所" sortable >
                    {{props.row.address }}
                  </b-table-column>
                  <b-table-column field="receiverName" label="宛名" width="200" sortable >
                    {{props.row.receiverName }}
                  </b-table-column>
                  <b-table-column field="phoneNumber" label="連絡先" width="100" sortable >
                    {{props.row.phoneNumber }}
                  </b-table-column>
                  <b-table-column field="biko" label="備考" sortable >
                    {{props.row.biko }}
                  </b-table-column>
                  <b-table-column field="patientName" label="氏名" width="150" sortable >
                    {{props.row.patientName }}
                  </b-table-column>
                  <b-table-column field="patientNameKana" label="フリガナ" width="150" sortable >
                    {{props.row.patientNameKana }}
                  </b-table-column>
                  <b-table-column field="gender" label="性別" width="80" sortable >
                    {{props.row.gender }}
                  </b-table-column>
                  <b-table-column field="birthday" label="生年月日" width="100" sortable >
                    {{props.row.birthday }}
                  </b-table-column>
                  <b-table-column field="height" label="身長" width="100" sortable >
                    {{props.row.height }}
                  </b-table-column>
                  <b-table-column field="weight" label="体重" width="100" sortable >
                    {{props.row.weight }}
                  </b-table-column>
                </template>
            </b-table>
        　</div>
        </div>
        <div class="button-area">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {LendingPeriod} from "@/components/mock/base/const.js";

export default {
  name: "KenshinShippingListDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinShippingList",
        params: { searchConditions: this.searchParams,field:this.sField,order:this.sOrder},
      });
    },
    getChoiceName: function(val,list) {
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    getStatusName: function(code) {
      var target = this.statusList.find(val => val.code && val.code.includes(code))
      if(target){
        return target.name
      }
      return ""
    },
    clipboardCopy: function() {
      var btable = document.getElementById('kenshinShippingListDetailTable');
      var tableWrapper = btable.getElementsByClassName('table-wrapper')[0];
      var table = tableWrapper.getElementsByTagName('table')[0];
      var tbody = table.getElementsByTagName('tbody')[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
        console.log(err);
      });
    },
    doShipping: function() {
      var excuteApi = this.setKenshinDeviceShipmentPOST;
      var successCallBack = this.setKenshinDeviceShipmentPOSTSuccess;
      var errorCallBack = this.setKenshinDeviceShipmentPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinDeviceShipmentPOST: function(client) {
      var returnDate = this.getBusinessDay(new Date(), this.lendingPeriod);
      returnDate = this.yyyy_sla_MM_sla_dd(returnDate)
      if(this.data.isAccommodations){
        returnDate = new Date(9999, 11, 31, 23, 59, 59, 999)
      }
      return client.apis.internalKenshin.setKenshinDeviceShipmentPOST({
        body:{
          receiptNumber:this.targetNumber,
          returnDate: returnDate
        }
      });
    },
    setKenshinDeviceShipmentPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setKenshinDeviceShipmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    doSearch: function() {
      var excuteApi = this.getKenshinDeviceShipmentDetailPOST;
      var successCallBack = this.getKenshinDeviceShipmentDetailPOSTSuccess;
      var errorCallBack = this.getKenshinDeviceShipmentDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinDeviceShipmentDetailPOST: function(client) {
      return client.apis.internalKenshin.getKenshinDeviceShipmentDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getKenshinDeviceShipmentDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.shippingDatas = this.data.shippingWorkList
      if(this.shippingStatus){
        this.shippingDatas = this.data.shippingWorkList.filter(val => {
          return val.status == this.shippingStatus
        })
      }
    },
    getKenshinDeviceShipmentDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    changeShippingStatus: function() {
      if(this.shippingStatus==0){
        this.shippingDatas = this.data.shippingWorkList
      }else{
        this.shippingDatas = this.data.shippingWorkList.filter(val => {
          return val.status == this.shippingStatus
        })
      }
    }
  },
  data() {
    var targetNumber = decodeURIComponent(this.$route.query["receiptNumber"]);
    var searchParams = this.$route.params["searchConditions"];
    var sField = this.$route.params["sortField"];
    var sOrder = this.$route.params["sortOrder"];
    let kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    var statusList = this.getStatusList()
    var shippingStatusList = [
      {code:3,name:"未出荷"},
      {code:4,name:"出荷済み"},
      {code:0,name:"全て"},
    ]
    return {
      targetNumber,
      searchParams,
      data: {},
      kenshinDeviceList,
      checkedRows:[],
      statusList,
      lendingPeriod:LendingPeriod.period,
      shippingStatusList,
      shippingStatus:3,
      shippingDatas:[],
      sField,
      sOrder
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.doSearch();
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.operation-area::after {
  content: "";
  display: block;
  clear: both;
  margin-bottom: 20px;
}
.operationButton {
  width:200px;
}
.resultTable-area {
  width: 1300px;
  overflow: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinShippingListDetail.vue